import {Observable, throwError} from "rxjs";
import {BaseHandler} from "@app/core/shared/data/network/base-handler";
import {HandlerBuilder, HttpMethod} from "@app/core/shared/data/network/base-handler.parameters";
import {ApiUrls} from "@app/core/shared/data/network/api-urls";
import {TokenAuthorization} from "@app/core/shared/data/network/token-authorization";
import {Injectable} from "@angular/core";
import {MissingCredentialsError} from "@app/core/shared/domain/missing-credentials.error";
import {TokenRepo} from "@app/core/shared/domain/token.repo";

@Injectable({
    providedIn: 'root',
})
export class SearchMatchPlayerWs {
    constructor(
        private handler: BaseHandler,
        private tokenRepo: TokenRepo,
    ) {}

    /**
     * Fetches the match player by email or name
     * @param query the email or name of the player
     */
    fetch(query: string): Observable<Record<string,any>[]> {
        const token = this.tokenRepo.get();
        if (token == null) {
            return throwError(() => new MissingCredentialsError());
        }
        const parameters = new HandlerBuilder()
            .setUrl(ApiUrls.SEARCH_MATCH_PLAYER_ENDPOINT())
            .setMethod(HttpMethod.get)
            .setAuthorization(new TokenAuthorization(token))
            .setUrlParams({
                search: query
            })
            .build();
        return this.handler
            .execute(parameters)
    }
}
